/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiOfficesQueryResponse,
  GetApiOfficesQueryParams,
} from '../models/GetApiOffices.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiOfficesQueryResponseSchema } from '../zod/getApiOfficesSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiOfficesQueryKey = (params: GetApiOfficesQueryParams) =>
  [{ url: '/api/offices' }, ...(params ? [params] : [])] as const;

export type GetApiOfficesQueryKey = ReturnType<typeof getApiOfficesQueryKey>;

/**
 * {@link /api/offices}
 */
export async function getApiOffices(
  params: GetApiOfficesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiOfficesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: `/api/offices`, params, ...requestConfig });
  return getApiOfficesQueryResponseSchema.parse(res.data);
}

export function getApiOfficesQueryOptions(
  params: GetApiOfficesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiOfficesQueryKey(params);
  return queryOptions<
    GetApiOfficesQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiOfficesQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiOffices(params, config);
    },
  });
}

/**
 * {@link /api/offices}
 */
export function useGetApiOffices<
  TData = GetApiOfficesQueryResponse,
  TQueryData = GetApiOfficesQueryResponse,
  TQueryKey extends QueryKey = GetApiOfficesQueryKey,
>(
  params: GetApiOfficesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiOfficesQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiOfficesQueryKey(params);

  const query = useQuery(
    {
      ...getApiOfficesQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
